/** Port von `IwmDialogContainerDokumenteList.razor` (`@inherits IwmDialogDokumentList`). */

import { useCallback } from 'react';

import { containerApi } from '@/api/services/containerApi';

import { DocumentListDialog } from './DocumentListDialog';
import { useContainerMatchcode } from './matchcode';

export interface ContainerDocumentListDialogProps {
  open: boolean;
  onClose: () => void;
  viewId: number;
  containerId: number;
}

export function ContainerDocumentListDialog(props: ContainerDocumentListDialogProps) {
  const { containerId, viewId } = props;
  const matchcode = useContainerMatchcode(props.open, viewId, containerId);

  // Port von `Fetch()`.
  const fetchDocuments = useCallback(
    () => containerApi.getDocuments(viewId, containerId),
    [containerId, viewId],
  );

  return (
    <DocumentListDialog
      open={props.open}
      onClose={props.onClose}
      matchcode={matchcode}
      fetchDocuments={fetchDocuments}
    />
  );
}

export default ContainerDocumentListDialog;
